/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
const Stripe = ({ Amount }) => {

    const { ApiBaseUrl, setApiLoading } = useContext(MyContext);
    const started = useRef(false);

    const HandleCall = () => {
        const Userid = secureLocalStorage.getItem("Userid");

        setApiLoading(true);
        axios.post(`${ApiBaseUrl}/customer/strip-payment`, { amount: Amount, uid: Userid, status: "1", })
            .then((res) => {
                // console.log("strip-payment", res);
                setTimeout(() => {
                    setApiLoading(false);
                }, 1000);
                window.location.href = res.data.StripeURL;
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        if (Amount && !started.current) {
            started.current = true;
            HandleCall();
        }
    }, [Amount]);

    return null;
};

export default Stripe;
/* jshint ignore:end */